
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 53 53"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.613 41.552l-7.907 4.313a7.106 7.106 0 00-1.269.903A26.377 26.377 0 0026.5 53c6.454 0 12.367-2.31 16.964-6.144a7.015 7.015 0 00-1.394-.934l-8.467-4.233a3.229 3.229 0 01-1.785-2.888v-3.322c.238-.271.51-.619.801-1.03a19.482 19.482 0 002.632-5.304c1.086-.335 1.886-1.338 1.886-2.53v-3.546c0-.78-.347-1.477-.886-1.965v-5.126s1.053-7.977-9.75-7.977-9.75 7.977-9.75 7.977v5.126a2.644 2.644 0 00-.886 1.965v3.546c0 .934.491 1.756 1.226 2.231.886 3.857 3.206 6.633 3.206 6.633v3.24a3.232 3.232 0 01-1.684 2.833z","fill":"#e7eced"}}),_c('path',{attrs:{"d":"M26.953.004C12.32-.246.254 11.414.004 26.047-.138 34.344 3.56 41.801 9.448 46.76a7.041 7.041 0 011.257-.894l7.907-4.313a3.23 3.23 0 001.683-2.835v-3.24s-2.321-2.776-3.206-6.633a2.66 2.66 0 01-1.226-2.231v-3.546c0-.78.347-1.477.886-1.965v-5.126S15.696 8 26.499 8s9.75 7.977 9.75 7.977v5.126c.54.488.886 1.185.886 1.965v3.546c0 1.192-.8 2.195-1.886 2.53a19.482 19.482 0 01-2.632 5.304c-.291.411-.563.759-.801 1.03V38.8c0 1.223.691 2.342 1.785 2.888l8.467 4.233a7.05 7.05 0 011.39.932c5.71-4.762 9.399-11.882 9.536-19.9C53.246 12.32 41.587.254 26.953.004z","fill":"#556080"}})])
          )
        }
      }
    